var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-speech-recognition",class:{
    error: _vm.error,
    active: _vm.isRecording
  },on:{"click":_vm.start}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }